module.exports = __webpack_public_path__ + "static/media/objects_18.2b5321b0.svg";